var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRental = function SvgRental(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.186,
    height: 38.874,
    viewBox: "0 0 37.186 38.874"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.218 3.78 3.785-1.624a3 3 0 0 1 4.183 2.757v29.048a3 3 0 0 1-4.183 2.757l-3.785-1.624V3.78z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.849 3.555a4 4 0 0 1 .025.445v30.874a4 4 0 0 1-4.445 3.975L3.555 36.176A4 4 0 0 1 0 32.2V6.674a4 4 0 0 1 3.555-3.976L27.429.025a4 4 0 0 1 4.42 3.53zm-7.058 13.226a2.656 2.656 0 1 0 0 5.312 2.656 2.656 0 0 0 0-5.312z"
  }))));
};
export default SvgRental;